module.exports = __webpack_public_path__ + "static/media/p1-bg-mask-extended.441e3d2b.svg";